var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2741_12430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0838C0 9.154 0 6.68913 0.959406 4.80619C1.80332 3.14991 3.14991 1.80332 4.80619 0.959406C6.68913 0 9.154 0 14.0838 0H15.9162C20.846 0 23.3109 0 25.1938 0.959406C26.8501 1.80332 28.1967 3.14991 29.0406 4.80619C30 6.68913 30 9.154 30 14.0838V15.9162C30 20.846 30 23.3109 29.0406 25.1938C28.1967 26.8501 26.8501 28.1967 25.1938 29.0406C23.3109 30 20.846 30 15.9162 30H14.0838C9.154 30 6.68913 30 4.80619 29.0406C3.14991 28.1967 1.80332 26.8501 0.959406 25.1938C0 23.3109 0 20.846 0 15.9162V14.0838Z",
    fill: "url(#paint0_linear_2741_12430)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6989 10.5859C21.6245 10.5859 20.6541 10.9108 19.8257 11.4669V6.39111H17.5338V15.7521C17.5338 18.6001 19.8509 20.8919 22.6863 20.8919C25.5217 20.8919 27.8651 18.6137 27.8651 15.7257C27.8651 12.8377 25.5731 10.5859 22.6989 10.5859ZM12.2978 16.4134L10.2004 10.9497H8.59508L6.48508 16.4134L4.37514 10.9497H1.875L5.56514 20.5567H7.17051L9.38457 14.8344L11.6113 20.5567H13.2166L16.8942 10.9497H14.4078L12.2978 16.4134ZM22.6874 18.6012C21.1336 18.6012 19.8257 17.3586 19.8257 15.7395C19.8257 14.1204 21.0558 12.8915 22.7 12.8915C24.3443 12.8915 25.5743 14.173 25.5743 15.7395C25.5743 17.3059 24.2664 18.6012 22.6874 18.6012Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2741_12430",
    x1: 10.0909,
    y1: 32.5909,
    x2: 28.5,
    y2: 1.90909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F01FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF49D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2741_12430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWb);
export default __webpack_public_path__ + "static/media/wb.c372f4448a757f4b152b865a20a1deb0.svg";
export { ForwardRef as ReactComponent };